<template>
  <div class="content_sider" :style="{ height: domHeight + 'px' }">
    <div class="content_title">
      <img src="../../assets/img/ysblogo.png" alt="" style="width: 70px; height: 70px" />
      <p class="welheahth" style="margin-top: 5px;font-size:22px">医知检</p>
    </div>

    <div class="gap_content" v-for="(item, i) in menus" :key="i">
      <div class="gap" v-show="activeIdx === i"></div>
      <div :class="activeIdx === i ? 'content_body' : 'content_active'" @click.stop="clickMenu(item, i)">
        <div>
          <img :src="require(`../../assets/img/${activeIdx === i ? item.activeIcon : item.icon}`)" />
          <p :class="activeIdx === i ? 'title_body' : 'title_active'">{{ item.title }}</p>
        </div>
      </div>
    </div>

    <div class="content_back" @click.stop="retrunBack">
      <div class="back_content">
        <img src="../../assets/img/home-back.png" alt="" />
        <p style="font-size: 12px; color: white">退出</p>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../common/bus';
export default {
  props: {
    domHeight: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      number: 1,
      activeIdx: 0,
      menus: [
        { title: '首页开单', icon: 'home1.png', activeIcon: 'home1-active.png', path: '/dashboard' },
        { title: '未完成订单', icon: 'home2.png', activeIcon: 'home2-active.png', path: '/uncomplete' },
        {
          title: '订单报告',
          icon: 'home33.png',
          activeIcon: 'home33-active.png',
          path: '/query'
        },
        { title: '患者管理', icon: 'home44.png', activeIcon: 'home44-active.png', path: '/patient' },
        { title: '我的诊所', icon: 'home4.png', activeIcon: 'home4-active.png', path: '/clinic' }
      ]
    };
  },
  computed: {
    // onRoutes() {
    //   return this.$route.path.replace('/', '');
    // }
  },
  created() {
    //刷新高亮回显
    this.menus.map((item, index) => {
      //干掉收样方
      if (localStorage.getItem('chooseSyf')) {
        localStorage.removeItem('chooseSyf');
      }
      localStorage.setItem('chooseProduct', JSON.stringify([])); //清空项目
      // 判断高亮
      if (item.path === this.$route.fullPath || item.path === this.$route.meta.fatherPath) {
        this.activeIdx = index;
        if (this.$route.meta.sourcePath && this.$route.meta.sourcePath === '/resetIndex') {
          this.activeIdx = 6;
        }
      }
    });

    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    // bus.$on('collapse', (msg) => {
    //   this.collapse = msg;
    //   bus.$emit('collapse-content', msg);
    // });
  },
  methods: {
    clickMenu(item, i) {
      //干掉收样方
      if (localStorage.getItem('chooseSyf')) {
        localStorage.removeItem('chooseSyf');
      }
      localStorage.setItem('chooseProduct', JSON.stringify([])); //清空项目
      // 正常操作
      if (i === 2) {
        // 点击订单报告
        bus.$emit('aliveTags', []);
      }
      this.activeIdx = i;
      this.$router.push(item.path);
    },
    retrunBack() {
      this.$confirm('确定要退出登录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false
      })
        .then(() => {
          if (localStorage.getItem('chooseSyf')) {
            localStorage.removeItem('chooseSyf');
          }            
          if(sessionStorage.getItem('user')){
            sessionStorage.removeItem('user');
          }
          this.$router.push('/login');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.content_sider {
  height: 100%;
  width: 128px;
  flex-shrink: 0;
  background: linear-gradient(0deg, #348aec, #36c6ff);
  box-shadow: 5px 0 10px rgba(0, 110, 255, 0.2);
  border-radius: 0px 30px 30px 0px;
  text-align: center;
  position: relative;
  z-index: 10;
  .content_back {
    width: 62px;
    height: 62px;
    border-radius: 24px;
    margin: 0 auto;
    background: #36b6ff;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;
    position: absolute;
    bottom: 28px;
    left: 50%;
    transform: translateX(-50%);
    .back_content {
      // height: 42px;
      // border: 1px solid red;
    }
  }
  .gap_content {
    width: 100%;
    // border: 1px solid darkgoldenrod;
    margin-bottom: 30px;
    cursor: pointer;
    position: relative;
    .gap {
      height: 36px;
      width: 8px;
      background: #fff;
      border-radius: 0px 8px 8px 0px;
      box-sizing: border-box;
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      left: 0px;
    }
  }
  .content_title {
    padding-top: 30px;
    width: 78px;
    height: 78px;
    border-radius: 24px;
    margin: 0 auto;
    // background: whitesmoke;
    margin-bottom: 50px;
    .welheahth {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .content_active {
    width: 78px;
    height: 78px;
    border-radius: 24px;
    margin: 0 auto;
    background: #36b6ff;
    // margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    box-sizing: border-box;
  }
  .content_body {
    width: 78px;
    height: 78px;
    border-radius: 24px;
    margin: 0 auto;
    background: #ffffff;
    // margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    box-sizing: border-box;
  }
  .title_body {
    font-size: 12px;
    color: #2d99d7;
    font-weight: bold;
  }
  .title_active {
    font-size: 12px;
    color: #fff;
  }
}
</style>
